
import jQuery from "jquery";
import { SavedListingRepository } from "../saved-listings/SavedListingRepository.js";
import {ZIDXListingSummary} from "../base.js";
import {ZIDX, ZIDXPage} from "../standaloneLibrary.js";
let $=jQuery.noConflict();

export class ZIDXSavedListings implements ZIDXPage {
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }

    getPageClass() {
        return "zidxSavedListingsContainer";
    }


    render() {
        let self=this;
        this.zidx.loadFunctions.push(async () => {
            // Sync with server first if logged in
            await SavedListingRepository.getInstance(self.zidx).syncWithServer();

            const listingIds = SavedListingRepository.getInstance(self.zidx).getListingIds();
            const obj = {
                id: "ajaxGetListings",
                method: "get",
                postObj: {},
                ignoreOldRequests: false,
                callback: (r: string) => {
                    let rs=JSON.parse(r);
                    if(!rs.success){
                        console.log(rs.errorMessage);
                        return;
                    }
                    const listings: Array<ZIDXListingSummary> = JSON.parse(rs.data);

                    const listingsContainer = $('#savedListingsContainer', self.zidx.peakidxShadowRoot);
                    listingsContainer.empty();
                    if(listings.length==0){
                        listingsContainer.append(`<div><p>You have no saved listings</p><p><a href="${this.zidx.getPrefixURL("/")}" class="zidxButton"">Search Listings</a></p></div>`);
                    }
                    for (let listing of listings) {
                        const link = this.zidx.zidxBase.getListingURL(listing);
                        const resultsContainer = $('<a></a>', self.zidx.peakidxShadowRoot).addClass('zidxSearchResultListingContainer zidxSavedListingContainer');
                        // resultsContainer.on('click', self.zidx.zidxBase.onSearchResultClick);
                        resultsContainer.attr("data-id", listing.id);
                        resultsContainer.on("click", (e:JQuery.ClickEvent) => {
                            e.preventDefault();
                            // console.log("link", link);
                            // return;
                            window.location.href=link;
                            // self.zidx.loadPushStateURL(link, false);
                        });
                        // resultsContainer.attr("details-link", link);
                        const content = this.renderListingThumbnailDetail(listing);
                        resultsContainer.html(content);
                        listingsContainer.append(resultsContainer);
                    }

                    this.zidx.zidxBase.bindSaveButtons();
                },
                errorCallback: function (r: string) {
                    console.log(r)
                },
                url: self.zidx.options.siteDomain+"/listings/?listing_ids=" + listingIds.join(",")
            };
            this.zidx.ajaxRequest(obj);
        })
    }

    renderListingThumbnailDetail(ss: ZIDXListingSummary): string {
        let arrHTML = [];
        const isSaved = SavedListingRepository.getInstance(this.zidx).isSaved(ss.id);

        arrHTML.push("<div title=\"View Listing\" class=\"zidxSearchDetailImage");
        arrHTML.push("\" style=\"background-image:url('" + ss.photo + "');\"");
        arrHTML.push("><span>" + this.zidx.zidxBase.htmlEditFormat("Photo of " + ss.address) + "</span></div>\n");

        arrHTML.push("<div class=\"zidxSearchDetailPrice\">");
        if (ss.price != 0) {
            arrHTML.push("$" + this.zidx.zidxBase.numberFormat(ss.price));
        }
        arrHTML.push("</div><div class=\"zidxSearchDetailSQFT\">");
        if (ss.sqft != 0) {
            arrHTML.push(ss.sqft + " SQFT");
        }
        arrHTML.push("</div><div class=\"zidxSearchDetailBeds\">");
        if (ss.bedrooms != 0) {
            arrHTML.push(ss.bedrooms + " Beds");
        }
        arrHTML.push("</div><div class=\"zidxSearchDetailBaths\">");
        if (ss.bathrooms != 0) {
            arrHTML.push(ss.bathrooms + " Baths");
        }
        if (ss.halfBaths != 0) {
            arrHTML.push("<br>" + ss.halfBaths + " Half Baths &nbsp; ");
        }
        arrHTML.push("</div>\n" +
            "            <div class=\"zidxSearchDetailType\">\n" +
            "            " + ss.type + "\n" +
            "        </div>\n" +
            "        <div class=\"zidxSearchDetailStatus\">\n" +
            "            " + ss.listStatus + "\n" +
            "        </div>\n" +
            "        <div class=\"zidxSearchDetailAddress\">\n" +
            "            " + ss.address + "<br>\n" +
            "        " + ss.city + ", " + ss.state + " " + ss.postalCode + "\n" +
            "        </div>");//\n" +
        // "        <div class=\"zidxSearchDetailButtons\">\n" +
        // "        <a href=\""+link+"\" class=\"zidxSearchResultListingButton\">\n" +
        // "            View Listing\n" +
        // "        </a>\n" +

        arrHTML.push(`
                    <div class=\"zidxSearchDetailSaveButton\">
                        <i title=\"Save property\" data-id='${ss.indexId+":"+ss.id}' data-unique-id='${ss.uniqueId}' saved='${isSaved}' class=\"fa ${isSaved ? 'fa-heart' : 'fa-heart-o'} zidxSearchResultSave\" aria-hidden=\"true\"></i>
                    </div>
            `);
        // "        </div>");
        return arrHTML.join("");
    }
}